import React, { useState, Suspense, lazy } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    createStyles,
    ActionIcon,
    Button,
    Collapse,
    Select,
    TextInput,
    NumberInput,
    Switch,
    Radio,
    SegmentedControl,
    Group
} from '@mantine/core';
import {
    IconUserPlus,
    IconUpload,
} from '@tabler/icons';
import {
    DatePicker,
    DateRangePicker,
    TimeInput
} from '@mantine/dates';
import { 
    nanoid,
    unwrapResult,
} from '@reduxjs/toolkit';
import { 
    carCreatorTextInfoUpdated,
    carCreatorSelectSectionDataB,
    fetchTests,
    testPost,
    testUpload,
    selectImage
} from '../features/auctionItemMgmt/auctionItemMgmtSlice';
import { 
    fieldInfoUpdated,
    selectSectionData,
} from '../features/home/homeSlice';
//descript:here for upload tests
import black_and_white_mercedes_benz from '../assets/black_and_white_mercedes_benz.jpg';
import pagani from '../assets/pagani.jpg';


const useStyles = createStyles((theme) => ({
    buttonContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        borderTop: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]
        }`,
    },
    buttonArea: {
        width: '49%',
        justifyContent: 'center',
    },
    buttonItem: {
        position: 'relative',
        left: '25%'
    }
    
}));

export function StaffFilter() {
    const { classes } = useStyles();
    const dispatch = useDispatch();
    
    const component_md = {
        par: 'staff',
        lvl: 0,
        child: 'all',
        section: 'allSection',
    }


    //works with stream line
    //cannot be simplified more
    const [alertMode, setAlertMode] = useState('All');
    const alertModes= [
        {
            label: 'All',
            value: 'All',
        },
        {
            label: 'Active',
            value: 'Active',
        },
        {
            label: 'Suspended',
            value: 'Suspended',
        },
        {
            label: 'Staff Type',
            value: 'Staff Type',
        },
    ];
    //loc_tests['title_loc_state'] = useState(strm_ln['listing_title_0']);


    return (
        <>
            <Group position="apart" >
                <Button color="green" leftIcon={<IconUserPlus />}>
                    New Staff
                </Button>
                <Button color="blue" leftIcon={<IconUpload />}>
                    Import Users
                </Button>
            </Group>
            <br/>
            <SegmentedControl
                fullWidth={true}
                value={alertMode}
                onChange={setAlertMode}
                data={alertModes}
            />
            
        </>
    );
    
}
